import React from 'react';

const CONFIGS = {
  fr: {
    buttonText: 'ACHETER POUR 23€',
    fontFamily: 'Kode Mono, monospace, sans-serif',
    buttonColor: '#BC202E',
    buttonHover: '#bd403b',
    href: 'https://www.amazon.fr/dp/B0GMK7W7RW',
  },
  en: {
    buttonText: 'BUY FOR $26',
    fontFamily: 'Kode Mono, monospace, sans-serif',
    buttonColor: '#BC202E',
    buttonHover: '#bd403b',
    href: 'https://www.amazon.com/dp/B0GMJZJFN5',
  },
};

export const getAmazonBookHref = (lang) =>
  (CONFIGS[lang] || CONFIGS.en).href;

const ShopifyBundleButton = ({ lang }) => {
  const config = CONFIGS[lang] || CONFIGS.fr;

  return (
    <a
      href={config.href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        textDecoration: 'none',
        fontFamily: config.fontFamily,
        fontWeight: 'bold',
        fontSize: 16,
        paddingTop: 17,
        paddingBottom: 17,
        paddingLeft: 24,
        paddingRight: 24,
        backgroundColor: config.buttonColor,
        borderRadius: 0,
        border: 'none',
        color: '#ffffff',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = config.buttonHover;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = config.buttonColor;
      }}
    >
      {config.buttonText}
    </a>
  );
};

export default ShopifyBundleButton;
